import { render } from "./NavLinks.vue?vue&type=template&id=15b921a0&scoped=true"
import script from "./NavLinks.vue?vue&type=script&lang=js"
export * from "./NavLinks.vue?vue&type=script&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=15b921a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15b921a0"

export default script